<template>
  <div class="merchantList">
    <div class="card-container">
      <div class="card-title">数据筛选</div>
      <div class="card-content">
        <a-form ref="searchForm" :form="form">
          <a-row>
            <a-col class="search-item" :span="6">
              <a-form-item
                label="区域"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
              >
                <a-cascader
                  v-model="areaContain"
                  :options="options"
                  :load-data="loadData"
                  :field-names="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="省市区"
                  change-on-select
                  @change="onAreaChange"
                />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item
                label="小区"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
              >
                <a-select
                  v-model="estate"
                  allow-clear
                  placeholder="全部"
                  show-search
                  option-filter-prop="children"
                >
                  <a-select-option
                    v-for="(item, index) in estateList"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.housingEstate }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item
                label="回收点名称"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
              >
                <a-input
                  v-model="activityName"
                  allow-clear
                  placeholder="请输入回收点名称"
                />
              </a-form-item>
            </a-col>
            <!-- <a-col class="search-item" :span="6">
              <a-form-item
                label="站长姓名"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
              >
                <a-input v-model="creater" allow-clear placeholder="请输入站长姓名" />
              </a-form-item>
            </a-col> -->
          </a-row>
          <a-row>
            <a-col class="search-item" :span="6">
              <a-form-item
                label="回收点类型"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
              >
                <a-select
                  v-model="type"
                  allow-clear
                  placeholder="全部"
                  show-search
                  option-filter-prop="children"
                >
                  <a-select-option value="1"> H20 </a-select-option>
                  <a-select-option value="2"> 移动回收点 </a-select-option>
                  <a-select-option value="3"> 加盟店 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item
                label="循环商店"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
              >
                <a-select
                  v-model="storeType"
                  allow-clear
                  placeholder="全部"
                  show-search
                  option-filter-prop="children"
                >
                  <a-select-option
                    v-for="(item, index) in cycleShop"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.storeName }}
                  </a-select-option>
                  <!-- <a-select-option value="1"> 自营店 </a-select-option>
                  <a-select-option value="2"> 加盟店 </a-select-option> -->
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col class="search-item" :span="24" align="right">
              <a-form-item>
                <a-button type="primary" class="mr8" @click="toSearch">
                  查询
                </a-button>
                <a-button @click="resetTable"> 重置 </a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div class="bottomContent">
      <div class="mb20">
        <a-row>
          <a-col :span="12" class="title"> 回收点列表 </a-col>
          <a-col :span="12" align="right">
            <a-button type="primary" @click="add()"> 添加回收点 </a-button>
          </a-col>
        </a-row>
      </div>
      <a-table
        :columns="columns"
        :data-source="tableData"
        :pagination="pagination"
        :row-key="record => record.id"
        :loading="loading"
        class="table-content"
        @change="handleTableChange"
      >
        <template slot="type" slot-scope="type">
          <span>{{ type == "1" ? "H20" : "" }}</span>
          <span>{{ type == "2" ? "移动回收点" : "" }}</span>
          <span>{{ type == "3" ? "自营店" : "" }}</span>
        </template>
        <template slot="BusinessTime" slot-scope="record">
          {{ record.beginBusinessTime }} - {{ record.endBusinessTime }}
        </template>
        <template slot="storeName" slot-scope="record">
          {{ record.storeName }}
        </template>

        <template slot="operate" slot-scope="text">
          <a-button type="link" size="small" @click="view(text)">
            查看
          </a-button>
          <a-button type="link" size="small" @click="edit(text)">
            编辑
          </a-button>
          <a-button type="link" size="small" @click="del(text)">
            删除
          </a-button>
        </template>
      </a-table>
    </div>
    <a-modal
      v-model="deleteVisible"
      ok-text="确定"
      cancel-text="取消"
      class="comModal"
      @ok="deleteModal"
    >
      <div class="dlContent">
        <icon-font type="iconShape" class="dlIcon"></icon-font>
        <span class="dlTitle">提示</span>
        <div class="dlMain">是否确定删除此回收点？</div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import {
  findPostHouseList,
  recycleUserList,
  getPostHouseInfo,
  delPostHouse,
  findPostHouseStoreList
} from "@/api/postManagement";
import {
  iconFontComponent,
  getArea,
  getEstate
} from "@/components/mixins/mixins.js";

const columns = [
  {
    title: "回收点名称",
    key: "name",
    dataIndex: "name"
  },
  {
    title: "详细地址",
    key: "address",
    dataIndex: "address"
  },
  {
    title: "回收点类型",
    key: "type",
    // scopedSlots: { customRender: "type" }
    dataIndex: 'type',
    customRender (text, record) {
      text = record.type == 1 ? 'H20' : record.type == 2 ? '移动回收点' : '加盟店'
      return text
    }
  },
  {
    title: "营业时间",
    key: "BusinessTime",
    scopedSlots: { customRender: "BusinessTime" }
  },
  {
    title: "循环商店",
    key: "storeName",
    scopedSlots: { customRender: "storeName" }
  },
  {
    title: "附近小区",
    key: "estateName",
    dataIndex: "estateName"
  },
  {
    title: "操作",
    key: "operate",
    width: 150,
    fixed: "right", // 固定在右边
    scopedSlots: { customRender: "operate" }
  }
];
export default {
  name: "MerchantList",
  mixins: [iconFontComponent, getArea, getEstate],
  data() {
    return {
      areaContain: [],
      form: this.$form.createForm(this),
      // merchantName: '',
      accountManagers: [
        {
          managerId: "全部",
          managerName: "全部"
        }
      ],
      accountManager: "全部",
      merchantTypes: [
        {
          id: "全部",
          name: "全部"
        },
        {
          id: "1",
          name: "实体商户"
        },
        {
          id: "2",
          name: "线上商户"
        },
        {
          id: "3",
          name: "综合商户"
        }
      ],
      merchantType: "全部",
      options: [],
      columns,
      tableData: [],
      loading: false,
      pagination: {
        current: 1,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => "共" + total + "条记录",
        pageSizeOptions: ["10", "20", "30", "40"],
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      },
      deleteVisible: false,
      delId: "",
      estate: undefined,
      activityName: "",
      estateList: [],
      type: "",
      storeType: "",
      types: [
        {
          id: 1,
          name: "H20"
        },
        {
          id: 2,
          name: "移动回收点"
        },
        {
          id: 3,
          name: "自营店"
        }
      ],
      params: {
        name: "",
        // managerName: '',
        province: "",
        city: "",
        areaId: "",
        estateId: "",
        page: "",
        pageSize: "",
        type: "", // 回收点类型
        storeType: "" // 商店类型
      },
      cycleShop:[], //循环商店列表
    };
  },
  // 没办法.....
  beforeRouteEnter(to, from, next) {
    if (from.name === "merchantDetails") {
      next(vm => {
        vm.load();
      });
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "merchantDetails") {
      from.meta.keepAlive = true;
      next();
    } else {
      from.meta.keepAlive = false;
      next();
    }
  },
  mounted() {
    this.load();
    this.getEstate();
  },
  methods: {
    load() {
      this.getArea("", 2, null, true);
      this.findPostHouseList();
      this.findPostHouseStoreList();
    },

    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      this.getArea(targetOption.id, targetOption.layer + 1, targetOption, true);
    },
    onAreaChange(value, obj) {
      this.estateList = [];
      this.estate = undefined;
      if (value.length < 4) {
        this.getEstate(value);
      } else if (value.length === 4) {
        this.getEstate(null, value[3]);
      }
    },
    findPostHouseList() {
      this.params = {
        name: this.activityName,
        province: this.areaContain.length > 0 ? this.areaContain[0] : "",
        city: this.areaContain.length > 0 ? this.areaContain[1] : "",
        areaId: this.areaContain.length > 0 ? this.areaContain[2] : "",
        estateId: this.estate,
        type: this.type, // 回收点类型
        storeId: this.storeType, //循环商店
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      this.loading = true;

      findPostHouseList(this.params).then(res => {
        this.loading = false;

        this.tableData = res.result.list;
        this.pagination.total = res.result.totalCount;
      });
    },

    // 获取循环商店列表信息
    findPostHouseStoreList() {

      this.params = {
        // name: this.storeName,
        // province: this.areaContain.length > 0 ? this.areaContain[0] : "",
        // city: this.areaContain.length > 0 ? this.areaContain[1] : "",
        // areaId: this.areaContain.length > 0 ? this.areaContain[2] : "",
        page: 1,
        pageSize: 1000
      };
      if (this.estate) {
        params.estateId = this.estate;
      }
      this.loading = true;

      findPostHouseStoreList(this.params)
        .then(res => {
          this.loading = false

          this.cycleShop = res.result // 这里的result.list打印的是undefined，去掉list之后是后台返回的有数据的数组

          // this.pagination.total = res.result.totalCount // 因为打印result里面没有包含totalCount
        })
        .catch(e => {
          this.$message.error("");
        });
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize;
      this.pagination.current = pagination.current;
      this.findPostHouseList();
    },
    initData() {
      const params = {};
      // params.menuId = '7d021664be58415cb158ba35b2645d72'
      params.page = this.pagination.current;
      params.pageSize = this.pagination.pageSize;
      if (this.areaContain.length !== 0) {
        if (this.areaContain[0]) {
          params.provinceId = this.areaContain[0];
        }
        if (this.areaContain[1]) {
          params.cityId = this.areaContain[1];
        }
        if (this.areaContain[2]) {
          params.areaId = this.areaContain[2];
        }
      }
      if (this.estate) {
        params.estateId = this.estate;
      }
      if (this.activityName) {
        params.title = this.activityName;
      }
      // if (this.creater) {
      //   params.createUser = this.creater
      // }
      this.findPostHouseList(params);
    },

    toSearch() {
      this.findPostHouseList();
    },
    resetTable() {
      this.areaContain = [];
      this.estate = undefined;
      this.activityName = "";
      this.type = "";
      this.storeType = "";
      const params = {};
      params.page = 1;
      params.pageSize = this.pagination.pageSize;
      this.findPostHouseList();
    },

    add(val) {
      this.$router.push({
        path: "/postManagement/add",
        query: { title: "添加", it: val }
      });
    },
    view(value) {
      this.$router.push({
        path: "/postManagement/add",
        query: { id: value.id, titless: "查看" }
      });
    },
    edit(value) {
      this.$router.push({
        path: "/postManagement/add",
        query: { id: value.id, title: "编辑" }
      });
    },
    del(value) {
      this.deleteVisible = true;
      this.delId = value.id;
    },
    deleteModal() {
      const params = {
        id: this.delId
      };
      // params.menuId = '015c6e1bc56246378963c308b2d408d5'

      delPostHouse(params).then(res => {
        this.$message.success(res.msg);
        this.deleteVisible = false;
        this.findPostHouseList();
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.merchantList {
  .w100 {
    width: 100%;
  }

  .mr8 {
    margin-right: 8px;
  }

  .bottomContent {
    background-color: #fff;
    padding: 16px 20px;

    .mb20 {
      margin-bottom: 20px;
    }
  }

  .title {
    color: #333;
    font-weight: 600;
    font-size: 16px;
  }

  .add-person {
    margin-right: 10px;
  }
}

.dlContent {
  .dlIcon {
    font-size: 30px;
  }

  .dlTitle {
    vertical-align: text-bottom;
    padding-left: 10px;
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }

  .dlMain {
    position: absolute;
    top: 64px;
    left: 64px;
    color: #666;
    font-size: 14px;
  }
}
</style>
<style lang="stylus">
.merchantList {
  .ant-btn-sm {
    padding-left: 0;
    padding-right: 10px;
  }
}
</style>
